import React from 'react';
import { useSelect } from 'downshift';

import Arrow from '@/assets/svg/arrow-down.svg';
import CheckIcon from '@/assets/svg/checkbox-tick.svg';
import CrossIcon from '@/assets/svg/close-12.svg';

import { RangeSelectProps } from '../types';
import {
  Component,
  Select,
  Content,
  Label,
  ListItem,
  SvgWrapper,
  ClearButton,
  NoOptions,
} from '../common.styles';

function MinRangeSelect({
  values,
  options,
  onChange,
  onClear,
}: RangeSelectProps) {
  const {
    isOpen,
    selectedItem,
    getToggleButtonProps,
    getItemProps,
    getMenuProps,
  } = useSelect({
    selectedItem: values.min,
    items: options,
    onSelectedItemChange: ({ selectedItem }) => {
      if (selectedItem?.value === values.min.value) {
        return;
      }

      onChange?.(selectedItem ?? options[0]);
    },
  });

  const handleClear = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    onClear?.('min');
  };

  return (
    <Component rangeType="min" isOpen={isOpen}>
      <Select type="button" {...getToggleButtonProps()}>
        <Label isSelectedItem={!!values.min.label}>
          {selectedItem?.label || 'От'}
        </Label>
        {onClear && selectedItem?.value && (
          <ClearButton onClick={handleClear}>
            <CrossIcon />
          </ClearButton>
        )}
        <SvgWrapper isOpen={isOpen}>
          <Arrow />
        </SvgWrapper>
      </Select>
      <Content {...getMenuProps()} isOpen={isOpen}>
        {options && options.length !== 0 ? (
          options.map((item, index) => {
            const isActive = item.label === selectedItem?.label;
            const disabled =
              values.max.value && Number(item.value) > Number(values.max.value);

            return (
              <ListItem
                key={index}
                {...getItemProps({
                  item: item,
                  index,
                })}
                isActive={isActive}
                disabled={disabled}
              >
                {item.label}
                {isActive && <CheckIcon />}
              </ListItem>
            );
          })
        ) : (
          <NoOptions>Нет опций</NoOptions>
        )}
      </Content>
    </Component>
  );
}

export default MinRangeSelect;
